import * as Sentry from '@sentry/react';

/**
 * Browser error reporting. The DSN is the only switch, as on the server
 * (server/src/instrument.ts): it is baked in at build time from the
 * `VITE_SENTRY_DSN` build arg, empty everywhere but a deployed build, and with
 * no DSN nothing is initialized and nothing leaves the page.
 *
 * What an event may carry is the server's rule: identifiers, never stored
 * content. So no Session Replay (it records the screen, and the screen is a
 * dossier) and no tracing, and default PII collection stays off. Uncaught
 * errors and unhandled rejections are what the default integrations report.
 * A failed API call is not reported here: the server reports its own 5xx, and a
 * 4xx is an answer.
 */
export function initErrorReporting(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
  if (!dsn) return;
  Sentry.init({
    dsn,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'prod',
    initialScope: { tags: { app: 'admin' } },
    sendDefaultPii: false,
    tracesSampleRate: 0,
    maxValueLength: 2000,
    maxBreadcrumbs: 50,
  });
}
